import React, { useEffect, useState } from 'react';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import DynamicTitleDescription from '../DynamicTitleDescription/DynamicTitleDescription';
import BikeFittingButton from '../button/BikeFittingButton';
import Trustpilot from '../../../../components/Reviews/Trustpilot';
import { useTranslation } from 'react-i18next';
import './style.css'
import { downloadGuide } from '../../actions';
import useScreenSize from '../../../../hooks/useScreenSize';
import CurrencyFormatter from '../../../../lib/CurrencyFormatter';
import useObjectFeatureFlag from "../../../../hooks/useObjectFeatureFlag";
import Locale from "../../../../lib/Locale";
import useFeatureFlag from "../../../../hooks/useFeatureFlag";
import TrustpilotWhite from '../../../../components/Reviews/Trustpilot/TrustPilotWhite';
import useStringFeatureFlag from '../../../../hooks/useStringFeatureFlag';

const Hero = ({ subscriptions }) => {
  const { t, i18n } = useTranslation("newLandingPage")
  const sm = useScreenSize(576);

  const [featureData, setFeatureData] = useState([]);
  const [cheapestSubscription, setCheapestSubscription] = useState({});
  const isSimplified = useFeatureFlag("simplified_checkout");
  const priceFeature = useFeatureFlag("show_price");
  const titleInfo = useObjectFeatureFlag("bikefitting_title");
  const bikefittingBg = useStringFeatureFlag("bikefitting_background");
  const descriptionInfo = useObjectFeatureFlag("bikefitting_subtitle");
  const [title, setTitle] = useState(t("heroTitle"));
  const [image, setImage] = useState(t("main-bike-fitting"));
  const [formate, setFormate] = useState(t("webp"));
  const [description, setDescription] = useState(t("heroDescription"));
  const [titleStyledWord, setTitleStyledWord] = useState("bikefitting Bike Fitting");

  useEffect(() => {
    const languageInfo = titleInfo?.[Locale.getLanguage()];

    if (languageInfo) {
      setTitle(languageInfo?.text);
      setTitleStyledWord(languageInfo?.styled);
    }
  }, [titleInfo, i18n.language]);

  useEffect(() => {
    const descriptionText = descriptionInfo?.[Locale.getLanguage()];

    if (descriptionText) {
      setDescription(descriptionText);
    }
  }, [descriptionInfo, i18n.language]);

  useEffect(() => {
    const data = [
      {
        type: "feature",
        title: '10.000+',
        description: t("Succesvolle bikefittings")
      }
    ];

    if (priceFeature) {
      data.push({
        type: "feature",
        title: CurrencyFormatter.format(cheapestSubscription?.price?.price ? cheapestSubscription.price.price / 100 : 0, cheapestSubscription?.price?.currency),
        description: t("Betaalbare bikefitting")
      });
    } else {
      data.push({
        type: "trustpilot"
      });
    }

    data.push({
      type: "feature",
      title: '15 min',
      description: t("Snel goed op de fiets")
    });

    setFeatureData(data);
  }, [priceFeature, subscriptions, cheapestSubscription, t]);

  useEffect(() => {
    setCheapestSubscription(subscriptions?.find(subscription => subscription.code === (isSimplified ? 'bikefit_simplified' : 'bikefit_once')))
  }, [subscriptions])

  useEffect(() => {
    //Mobile browsers (especially Safari and Chrome on iOS/Android) often shrink the usable viewport with their dynamic address and navigation bars. Using vh (viewport height) alone can cause layout issues because 100vh isn't always the "visible" height. To fix the issue we are using app-height to exclude dynamically the bars height
    const setAppHeight = () => {
      const navbarHeight = '83'
      document.documentElement.style.setProperty('--app-height', `${window.innerHeight - navbarHeight}px`);
    };

    setAppHeight();
    window.addEventListener('resize', setAppHeight);
    window.addEventListener('orientationchange', setAppHeight);

    return () => {
      window.removeEventListener('resize', setAppHeight);
      window.removeEventListener('orientationchange', setAppHeight);
    };
  }, []);
  
  useEffect(() => {
    setImage(bikefittingBg === 'current' ? "main-bike-fitting" : bikefittingBg === 'enhanced' ? "Hero_image_B_color_improvements" : bikefittingBg === 'new' ? "Cyclist_with_bike_fit_nodes" : "main-bike-fitting")
    setFormate(bikefittingBg === 'current' ? "webp" : bikefittingBg === 'enhanced' ? "jpg" : bikefittingBg === 'new' ? "jpg" : "webp")
  }, [bikefittingBg])


  const Feature = ({title, description}) => (
    <div className='text-white text-md-center text-left py-1'>
      <p className='m-0 font-bold text-xl'>{title}</p>
      <p className='m-0 px-0 px-md-2 text-l font-bold'>{description}</p>
    </div>
  )

  const TrustPilotFeature = () => (
    <div className='text-white text-md-center text-left py-1 d-flex flex-column justify-content-center'>
      <Trustpilot />
    </div>
  )

  return (
    <div className='app-height'>
      <div className={`position-relative hero-top ${bikefittingBg === 'new' ? 'img-filter' : ''}`}>
        <img className={`${bikefittingBg === 'new' ? 'img-fit-for-new-bg' : 'img-fit'}`} src={`img/newLandingPage/hero/${t(image)}.${formate}`} alt={t("mainBikeFittingAlt")} />

        <div className='container p-md-0 p-3 position-absolute h-100 d-flex flex-column justify-content-around hero-content' style={sm ? { top: '0', width: '100%' } : { left: '0%', right: '0%', top: '0' }}>

          <div className='text-left heroTitleDescriptionButtonWrapper'>
            <DynamicTitleDescription description={description} title={title} styledWord={titleStyledWord} color="#F4DE58" classNames="text-left text-white" isHeader={true}
            />
            <BikeFittingButton buttonColor="#F4DE58" />
          </div>

          <div className='trustpilot-wrapper d-block d-sm-flex justify-content-between'>
            <div className="ratingWrapper mb-3">
              {priceFeature && bikefittingBg === 'new' ? <TrustpilotWhite /> : <Trustpilot />}
            </div>

            {/* download guide */}
            <div className='d-flex downloadGuideParent' onClick={() => downloadGuide(t)}>
              <div className="position-relative bg-white text-left py-4 px-3 m-0 text-l border-10px" >
                <p className='m-0 font-weight-bold' >{t("dCardTitle")}</p>
                <p className='m-0'>{t("dCardDescription")}</p>
                <div className='d-flex justify-content-center align-items-center absolute-circle'>
                  <img style={{ width: '60%' }} src="/img/newLandingPage/icon/Downlaod_Icon.png" alt="" />
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <div className='bg-red-orange hero-bottom d-flex align-items-center'>
        <div className='d-flex justify-content-between py-sm-4 py-1 container'>
          {featureData?.map(
            (feature, index) => feature.type === "trustpilot" ? <TrustPilotFeature key={`features-${index}`} /> :
              <Feature key={`features-${index}`} title={feature.title} description={feature.description} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero;
